import { useCallback, useEffect, useState } from "react";
import api from "../services/api";

export const PROPOSTAS_COMERCIAIS = "propostas_comerciais";

/**
 * Quando o painel admin não está configurado (sem INSTANCE_ID/URL), mantém módulos legados visíveis.
 */
export function isFeatureOn(configured, features, key) {
  if (!configured) return true;
  return features?.[key] === true;
}

export default function useFeatureFlags() {
  const [configured, setConfigured] = useState(false);
  const [features, setFeatures] = useState({});
  const [loaded, setLoaded] = useState(false);

  const load = useCallback(async () => {
    try {
      const { data } = await api.get("/feature-flags");
      setConfigured(Boolean(data?.configured));
      setFeatures(data?.features ?? {});
    } catch {
      setConfigured(false);
      setFeatures({});
    } finally {
      setLoaded(true);
    }
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  const isEnabled = useCallback(
    (key) => isFeatureOn(configured, features, key),
    [configured, features]
  );

  return { configured, features, loaded, isEnabled, reload: load };
}
